import { baseApi } from './baseApi';
import { buildListQueryParams } from '../utils/pagination';

export const productTypeApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getProductTypes: builder.query({
      query: (args = {}) => ({
        url: '/api/product_types',
        params: buildListQueryParams({ status: true, ...args }),
      }),
      providesTags: ['ProductTypes'],
    }),
  }),
});

export const { useGetProductTypesQuery } = productTypeApi;
